"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Spinner = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: 'd-flex justify-content-center w-100', children: (0, jsx_runtime_1.jsx)("div", { className: `spinner spinner-track spinner-${props.color} ${props.size && 'spinner-' + props.size}` }) }));
};
exports.default = Spinner;
